import React from 'react';
import Backgroundimage from '../../assets/images/background/image-4.webp';
import { Link } from 'react-router-dom'
import logonew from '../../assets/images/logo.png'

function Main() {
    return (
        <>
            <footer className="main-footer">
                <div className="image-layer" style={{ backgroundImage: `url(${Backgroundimage})` }}> </div>
                <div className="upper-section">
                    <div className="auto-container">
                        <div className="row clearfix">
                            <div className="footer-col info-col col-lg-6 col-md-12 col-sm-12">
                                <div className="inner wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                                    <div className="content">
                                        <div className="logo"><Link to="/" title="Kin Ramen"><img src={logonew} alt="" title="Kin Ramen" /></Link></div>
                                        <div className="info">
                                            <ul>
                                                <li>129 W 56th St, New York, NY 10019</li>
                                                <li><Link to="tel:+12129339292" className="theme_color">+1(212) 933-9292</Link></li>
                                                <li>&nbsp;</li>
                                                <li >Monday to Sunday</li>
                                                <li className="theme_color">12:00 pm - 03:00 pm</li>
                                                <li className="theme_color">04:30 pm - 10:00 pm</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="footer-col links-col col-lg-3 col-md-6 col-sm-12">
                                <div className="inner wow fadeInLeft" data-wow-delay="0ms" data-wow-duration="1500ms">
                                </div>
                            </div>

                            <div className="footer-col links-col last col-lg-3 col-md-6 col-sm-12">
                                <div className="inner wow fadeInRight" data-wow-delay="0ms" data-wow-duration="1500ms">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <div className="auto-container">
                        <div className="copyright">&copy;2025 Restaurt. All Rights Reserved | Crafted by iOz</div>
                    </div>
                </div>

            </footer>
            <div className="scroll-to-top scroll-to-target" data-target="html"><span className="icon fa fa-angle-up"></span></div>
        </>
    )
}

export default Main
